import styles from './styles.module.scss';
import clsx from 'clsx';

type InputProps = {
  isLoading: boolean;
  classNameWrapper?: string;
};

export const AnimatedLoader = ({ isLoading }: InputProps) => {
  return (
    <div className={clsx(styles.root, !isLoading && styles.complete)}>
      <div
        className={clsx(
          styles.checkmark,
          styles.draw,
          isLoading && styles.hide
        )}
      ></div>
    </div>
  );
};

export const AnimatedLoaderModal = ({
  isLoading,
  classNameWrapper,
}: InputProps) => {
  return (
    <div className={clsx(styles.wrapper, classNameWrapper)}>
      <div className={clsx(styles.root, !isLoading && styles.complete)}>
        <div
          className={clsx(
            styles.checkmark,
            styles.draw,
            isLoading && styles.hide
          )}
        ></div>
      </div>
    </div>
  );
};
